import { Component, OnInit,Input } from '@angular/core';
import { SharedService } from 'src/app/core/services/shared.service';

@Component({
  selector: 'app-email-details',
  templateUrl: './email-details.component.html',
  styleUrls: ['./email-details.component.scss']
})
export class EmailDetailsComponent implements OnInit {

  strWsnotidetail: string = "api/servicios/NotificacionesDetalle";
  data: any;
  breadCrumbItems: Array<{}>;
  @Input()  WsLlaves: string = '';

  constructor(private dataService: SharedService) { }

  ngOnInit(): void {
    this.dataService.ConsultarWS(this.strWsnotidetail+"/"+this.WsLlaves).subscribe(
     (datosResp: any) => {       
       this.data = datosResp;  
     });
 }

}
